import type { Player } from '../player';
import { setEngineState, SFX } from '../audio';

interface EngineDeps {
  keys: { boost: boolean };
  respawnT: number;
}

// Drive the continuous engine + friction layer + the periodic mission-comms beacon ping.
// Owns its own beacon timer; pause/title states should call `mute()` to fade out cleanly.
export class EngineAudio {
  private beaconT = 10;

  tick(dt: number, player: Player, deps: EngineDeps): void {
    const sp = Math.hypot(player.vx, player.vy);
    const boostActive = deps.keys.boost && player.shield > 0;
    const cap = boostActive ? 1100 : 700;
    const alive = deps.respawnT <= 0 && player.hp > 0;
    setEngineState(sp / cap, boostActive, alive);
    // Mission-comms beacon every 10s while alive
    if (alive) {
      this.beaconT -= dt;
      if (this.beaconT <= 0) {
        SFX.beacon();
        this.beaconT = 10;
      }
    }
  }

  mute(): void {
    setEngineState(0, false, false);
  }
}
